<!--
  Downloads page (per PDF design)
  All Resources | Brochures | Travel Guides | Maps | Safety Guides
  Flipbook viewer loads each card's own PDF from the API (item.field_pdf).
  The featured "Islands Brochure" uses the last Brochure item's field_pdf.
  "Download PDF" still uses the item's API field_pdf.
-->

<!-- Fullscreen galleria for banner image -->
<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item> <img [src]="item" class="gallery-image" /> </ng-template>
</p-galleria>

<!-- Banner -->
<div
  class="innerBanner specialInterestBanner"
  [style.background-image]="'url(' + downloadsDetails.bannerImage + ')'"
  style="cursor: pointer"
  (click)="imageClick(0)"
>
  <div class="bannerText">
    <h1 style="text-transform: uppercase; font-size: 12vh">{{ downloadsDetails.bannerTitle | translate }}</h1>
  </div>
  <div class="mouse_scroll" (click)="scollBottom()">
    <div class="mouse">
      <div class="wheel"></div>
    </div>
    <div>
      <span class="m_scroll_arrows unu"></span>
      <span class="m_scroll_arrows doi"></span>
      <span class="m_scroll_arrows trei"></span>
    </div>
  </div>
</div>

<!-- Breadcrumb + intro -->
<div class="container contentPanel">
  <app-breadcrumb-row></app-breadcrumb-row>
  <div class="pageTitle">
    <p [innerHTML]="downloadsDetails.content"></p>
  </div>
</div>

<div class="downloads-revamp">
  <div class="container">
    <!-- Trusted heading -->
    <div class="trusted-block text-center">
      <h2 class="trusted-title">{{ 'Trusted. Official. Always at your fingertips' | translate }}</h2>
      <p class="trusted-subtitle">
        {{ 'resources_description' | translate }}
      </p>
    </div>

    <!-- Search (autocomplete) -->
    <div class="downloads-search">
      <p-autoComplete
        [ngModel]="selectedItem"
        (ngModelChange)="onSearchChange($event)"
        [suggestions]="suggestions"
        (completeMethod)="searchDownloads($event)"
        (onSelect)="onSelectDownload($event)"
        (onClear)="clearSearch()"
        [minLength]="2"
        [delay]="300"
        field="title"
        styleClass="dl-autocomplete"
        [placeholder]="'Search downloads...' | translate"
      >
        <ng-template let-item pTemplate="item">
          <div class="dl-suggestion">
            <span class="dl-suggestion-title">{{ item.title }}</span>
            <span class="dl-suggestion-cat">{{ item.field_downloads_category }}</span>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>

    <!-- Tabs -->
    <div class="downloads-tabs-wrap">
      <div class="downloads-tabs">
        <div
          class="downloads-tab"
          *ngFor="let tab of tabs"
          (click)="selectTab(tab)"
          [class.active]="activeTabLabel === tab.label"
        >
          {{ tab.label | translate }}
        </div>
      </div>
    </div>

    <!-- Featured publication -->
    <div class="featured-card" *ngIf="featuredItem">
      <div class="row no-gutters">
        <div class="col-lg-4 featured-info">
          <span class="featured-label">{{ 'FEATURED PUBLICATION' | translate }}</span>
          <h3 class="featured-title">{{ featuredItem.title }}</h3>
          <p class="featured-desc" [innerHTML]="featuredItem.body"></p>
          <div class="featured-actions">
            <button class="btn-outline-red" (click)="openFlipbook(featuredItem)">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M2 4h7a3 3 0 0 1 3 3v13a2.5 2.5 0 0 0-2.5-2.5H2z"></path>
                <path d="M22 4h-7a3 3 0 0 0-3 3v13a2.5 2.5 0 0 1 2.5-2.5H22z"></path>
              </svg>
              {{ 'Read' | translate }}
            </button>
            <button class="btn-outline-red" (click)="saftyPdf(featuredItem.nid, featuredItem.field_pdf)">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 3v12"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="5" y1="21" x2="19" y2="21"></line>
              </svg>
              {{ 'Download PDF' | translate }}
            </button>
          </div>
        </div>
        <div class="col-lg-8 featured-viewer">
          <!-- Inline flipbook preview of the featured brochure (streamed via API) -->
          <app-flipbook [pdfSrc]="featuredViewerUrl"></app-flipbook>
        </div>
      </div>
    </div>

    <!-- Explore all resources -->
    <h2 class="explore-title text-center">{{ 'Explore all resources' | translate }}</h2>

    <div class="resource-grid" *ngIf="displayedResults && displayedResults.length">
      <div class="resource-card" *ngFor="let item of displayedResults">
        <span class="resource-cat">{{ item.field_downloads_category | translate }}</span>
        <div class="resource-thumb">
          <img [src]="item.field_images" [alt]="item.title" />
        </div>
        <h4 class="resource-title" role="heading" aria-level="2">{{ item.title }}</h4>
        <p class="resource-desc" [innerHTML]="item.body"></p>
        <div class="resource-actions">
          <button class="btn-outline-red w-100" (click)="openFlipbook(item)">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M2 4h7a3 3 0 0 1 3 3v13a2.5 2.5 0 0 0-2.5-2.5H2z"></path>
              <path d="M22 4h-7a3 3 0 0 0-3 3v13a2.5 2.5 0 0 1 2.5-2.5H22z"></path>
            </svg>
            {{ 'Read' | translate }}
          </button>
          <button class="btn-outline-red w-100" (click)="saftyPdf(item.nid, item.field_pdf)">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3v12"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="5" y1="21" x2="19" y2="21"></line>
            </svg>
            {{ 'Download PDF' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="no-results text-center" *ngIf="!displayedResults || !displayedResults.length">
      {{ 'No resources found' | translate }}
    </div>

    <!-- View all -->
    <div class="text-center view-all-wrap" *ngIf="filteredResults.length > displayLimit && !showAllResources">
      <button class="btn-outline-red view-all-btn" (click)="viewAllResources()">
        {{ 'View all resources' | translate }}
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>

    <!-- Help banner -->
    <div class="help-banner">
      <div class="help-icon">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="9"></circle>
          <line x1="12" y1="11" x2="12" y2="16"></line>
          <circle cx="12" cy="7.7" r="0.7" fill="currentColor" stroke="none"></circle>
        </svg>
      </div>
      <div class="help-text">
        <h4 role="heading" aria-level="2">{{ "Can't find what you're looking for?" | translate }}</h4>
        <p>{{ 'Our team is here to help you find the right resource.' | translate }}</p>
      </div>
      <a class="btn-solid-red" routerLink="/contactus">{{ 'Contact Us' | translate }}</a>
    </div>
  </div>
</div>

<!-- Flipbook modal (opened by "Read") -->
<div class="flipbook-modal" *ngIf="showFlipbook">
  <div class="flipbook-modal-backdrop" (click)="closeFlipbook()"></div>
  <div class="flipbook-modal-body">
    <button type="button" class="flipbook-modal-close" (click)="closeFlipbook()">&times;</button>
    <app-flipbook [pdfSrc]="flipbookPdf" [documentTitle]="flipbookTitle"></app-flipbook>
  </div>
</div>
